export const trackEvent = (
    eventName99d: string,
    eventNameVistaprint: string,
    properties: BaseTracking
) => {
    let trackFn = null;
    let eventName = eventName99d;

    // Tracking for 99d
    if (typeof window !== 'undefined' && window.analytics) {
        trackFn = window.analytics.track;
    }

    // Tracking for Vistaprint
    if (typeof window !== 'undefined' && window.tracking) {
        eventName = eventNameVistaprint;
        trackFn = window.tracking.track;
    }

    const trackParams = window.trackParams || {};

    if (!trackFn) {
        return;
    }

    trackFn(eventName, {
        ...trackParams,
        ...properties,
    });
};
